import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar/sidebar";
import {
  createResetData,
  getListData,
  updateData,
} from "../../hooks/api/utils";
import CommonModal from "../../components/modal/modal";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slices/authSlice";

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPasswordFields, setShowPasswordFields] = useState({
    current: false,
    new: false,
    confirm: false,
  });
  const [formData, setFormData] = useState({
    id: "",
    email: "",
    phone: "",
  });
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    current_password: "",
    password: "",
    confirm_password: "",
  });
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [passwordErrors, setPasswordErrors] = useState({});
  const [previewUrl] = useState("/images/profile-sample.svg");
  const refreshToken = useSelector((state) => state.auth?.token?.refresh);
  const user = useSelector((state) => state?.auth?.user);

  useEffect(() => {
    setLoading(true);
    getListData("/admin-panel/admin-profile/", setLoading, (data) => {
      setFormData({
        id: data?.data?.id || "",
        email: data?.data?.email || "",
        phone: data?.data?.phone || "",
      });
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleConfirmSubmit = () => {
    setLoading(true);
    const body = {
      phone: formData.phone,
    };

    updateData(
      "/admin-panel/admin-profile/",
      formData.id,
      setLoading,
      body,
      navigate,
      "/dashboard"
    );
    setIsModalOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = {};

    // Phone validation
    if (!formData.phone.trim()) {
      errors.phone = "Phone number is required";
    } else if (!/^\d{10}$/.test(formData.phone)) {
      errors.phone = "Phone number must be 10 digits";
    }

    setFormErrors(errors);

    // Show modal only if no validation errors
    if (Object.keys(errors).length === 0) {
      setIsModalOpen(true);
    }
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswordFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handlePasswordSubmit = () => {
    const errors = {};

    if (!passwordForm.current_password.trim()) {
      errors.current_password = "Current password is required";
    }

    if (!passwordForm.password.trim()) {
      errors.password = "New password is required";
    } else if (passwordForm.password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    if (!passwordForm.confirm_password.trim()) {
      errors.confirm_password = "Confirm password is required";
    } else if (passwordForm.password !== passwordForm.confirm_password) {
      errors.confirm_password = "Passwords do not match";
    }

    setPasswordErrors(errors);

    if (Object.keys(errors).length > 0) return;

    const body = {
      current_password: passwordForm.current_password,
      password: passwordForm.password,
      confirm_password: passwordForm.confirm_password,
      refresh: refreshToken,
    };

    createResetData(
      "/users/reset-password/",
      setLoading,
      body,
      () => {
        dispatch(logout());
      },
      "/",
      navigate
    );

    setIsPasswordModalOpen(false);
  };
  return (
    
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Profile</h4>
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-12 text-center mb-4">
                      {/* <label
                        htmlFor="profileUpload"
                        style={{ cursor: "pointer" }}
                      >
                        <img
                          src={previewUrl}
                          alt="Profile"
                          className="rounded-circle"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                      </label> */}
                      {(user?.first_name || user?.last_name) && (
                        <div className="mt-2 fw-bold fs-4">
                          {user?.first_name} {user?.last_name}
                        </div>
                      )}
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          readOnly
                          disabled
                          className="form-control"
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Phone Number</label>
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter your Phone Number"
                          className="form-control"
                        />
                        {formErrors.phone && (
                          <div
                            className="text-danger mt-1"
                            style={{ fontSize: "14px" }}
                          >
                            {formErrors.phone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <label className="form-label">Password</label>
                      <div className="d-flex align-items-center border rounded px-3 py-2 justify-content-between">
                        <div className="d-flex align-items-center">
                          <div className="me-3 text-muted">
                            <img
                              src="../images/lockIcon.svg"
                              alt="lock Icon"
                              className="img-fluid"
                            />
                          </div>
                          <div>
                            <div
                              className="text-muted"
                              style={{ fontSize: "14px" }}
                            >
                              Current password
                            </div>
                            <div
                              className="fw-bold"
                              style={{ letterSpacing: "4px", fontSize: "14px" }}
                            >
                              ••••••••••
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="text-blue text-decoration-none fw-semibold bg-transparent border-0"
                          onClick={() => setIsPasswordModalOpen(true)}
                        >
                          Change
                        </button>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="d-flex gap-3 justify-content-end">
                        <Link
                          to="/dashboard"
                          type="button"
                          className="transparent_btn"
                        >
                          Cancel
                        </Link>
                        <button type="submit" className="blue_btn">
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
                {/* change password  */}
                <CommonModal
                  isOpen={isPasswordModalOpen}
                  onRequestClose={() => setIsPasswordModalOpen(false)}
                  title="Change Password"
                >
                  <div className="form-group mb-3 position-relative">
                    <label>Current Password</label>
                    <input
                      type={showPasswordFields.current ? "text" : "password"}
                      name="current_password"
                      value={passwordForm?.current_password}
                      onChange={handlePasswordChange}
                      className="form-control"
                      placeholder="Enter current password"
                    />
                    <span
                      onClick={() => togglePasswordVisibility("current")}
                      className="eye-icon"
                    >
                      {showPasswordFields.current ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    {passwordErrors.current_password && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      >
                        {passwordErrors.current_password}
                      </div>
                    )}
                  </div>
                  <div className="form-group mb-3 position-relative">
                    <label>New Password</label>
                    <input
                      type={showPasswordFields.new ? "text" : "password"}
                      name="password"
                      value={passwordForm?.password}
                      onChange={handlePasswordChange}
                      className="form-control"
                      placeholder="Enter new password"
                    />
                    <span
                      onClick={() => togglePasswordVisibility("new")}
                      className="eye-icon"
                    >
                      {showPasswordFields.new ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    {passwordErrors.password && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      >
                        {passwordErrors.password}
                      </div>
                    )}
                  </div>

                  <div className="form-group mb-4 position-relative">
                    <label>Confirm New Password</label>
                    <input
                      type={showPasswordFields.confirm ? "text" : "password"}
                      name="confirm_password"
                      value={passwordForm?.confirm_password}
                      onChange={handlePasswordChange}
                      className="form-control"
                      placeholder="Confirm new password"
                    />
                    <span
                      onClick={() => togglePasswordVisibility("confirm")}
                      className="eye-icon"
                    >
                      {showPasswordFields.confirm ? <FaEyeSlash /> : <FaEye />}
                    </span>
                    {passwordErrors.confirm_password && (
                      <div
                        className="text-danger mt-1"
                        style={{ fontSize: "14px" }}
                      >
                        {passwordErrors.confirm_password}
                      </div>
                    )}
                  </div>

                  <div className="d-flex justify-content-end gap-3">
                    <button
                      className="transparent_btn"
                      onClick={() => setIsPasswordModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button className="blue_btn" onClick={handlePasswordSubmit}>
                      Update
                    </button>
                  </div>
                </CommonModal>
                {/* Confirmation Modal */}
                <CommonModal
                  isOpen={isModalOpen}
                  onRequestClose={() => setIsModalOpen(false)}
                  title="Save changes ?"
                >
                  <p className="text-center">
                    You want to wish to save changes of the user <br />
                    <span className="text-blue">Alex Whitefield ?</span>{" "}
                  </p>
                  <div className="d-flex justify-content-end gap-3 mt-4">
                    <button
                      className="transparent_btn"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button className="blue_btn" onClick={handleConfirmSubmit}>
                      Confirm
                    </button>
                  </div>
                </CommonModal>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Profile;
